module.exports = __webpack_public_path__ + "static/media/texture2.23fea767.png";